import { useEffect } from "react";
import { BackButton, ProgressBar } from "../../_ui";
import store from "../../../_services/store";
import { Container, GeneralProgressionLabel, ReadProgressContainer } from "./components";

import { COLORS } from "../../../constants";
import { round } from "../../../_services/utils/utils";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../router/routes";
import { observer } from "mobx-react";

const QuizzSelection = observer(() => {
  const navigate = useNavigate();

  const loadQuiz = (id: string) => {
    store.setQuizzId(id);
    navigate(ROUTES.QUIZZ());
  };
  
  const quizzes = store.quizzes?.quizPercentageResult.map(quizz =>
    <ReadProgressContainer
      key={`quizz_${quizz.quiz_name}_${quizz.quiz_id}`}
      onClick={() => loadQuiz(quizz.quiz_id)}
      style={{ cursor: 'pointer' }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", width: '100%' }}>
        <GeneralProgressionLabel>{quizz.quiz_name}</GeneralProgressionLabel>
        <GeneralProgressionLabel>{`${round(+quizz.percentage * 100)}%`}</GeneralProgressionLabel>
      </div>

      <ProgressBar
        percentage={round(+quizz.percentage * 100)}
        height="12px"
        fillColor={COLORS.PRIMARY}
        backgroundColor={COLORS.PRIMARY + "33"}
      />
    </ReadProgressContainer>
  )

  return (
    <div>
      <BackButton title={store.currentLevel?.title || "error"} desc={store.currentLevel?.desc} />
      <Container style={{marginBottom: '120px'}}>
        {quizzes}
      </Container>
    </div>
  )
})

export default QuizzSelection;